import React from "react";

import QrCodeDisplay from "../qr_code_display/QrCodeDisplay";

/**
 *
 * @param props.value
 * @param {Number} props.width
 * @param {Boolean} props.onCodeClick
 */
export default function ScannableCodeDisplay(props) {

	/*
		right now, there's only QR ... but bar could be coming
	 */

	return (
		<QrCodeDisplay {...props} />
	);
}